import React, { useState } from 'react';
import './CopyRedemptionCode.css';

interface CopyRedemptionCodeProps {
  code: string;
  className?: string;
  codeClassName?: string;
  buttonClassName?: string;
}

const CopyRedemptionCode: React.FC<CopyRedemptionCodeProps> = ({
  code,
  className,
  codeClassName,
  buttonClassName,
}) => {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  return (
    <div className={className ?? 'copy-redemption-code'}>
      <span className={codeClassName ?? 'copy-redemption-code__value'}>{code}</span>
      <button
        type="button"
        className={buttonClassName ?? 'copy-redemption-code__btn'}
        onClick={handleCopy}
        aria-label={copied ? 'Code copied' : 'Copy redemption code'}
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
    </div>
  );
};

export default CopyRedemptionCode;
